var initialExperimentBackendStatus = {
  loading: false,
  error: false,
  status: null
};
var initialState = {};
export default initialState;
export { initialExperimentBackendStatus };